import { sendEmail } from "../../misc/sendEmail";
import type { EmailTemplateOrder } from "../../orders/emails/useProviderEmailTemplates";
import { InvoiceForBookingEmailTemplate } from "../../orders/emails/useProviderEmailTemplates";

export const useInvoiceEmailTemplate = ({
  order,
  bookingNumber,
  providerEmail,
  productEmails,
}: {
  order: Pick<EmailTemplateOrder, "name" | "userFriendlyId">;
  bookingNumber: string;
  providerEmail: string;
  productEmails: string[];
}) => {
  return {
    send: () => {
      const template = new InvoiceForBookingEmailTemplate(order, [bookingNumber], providerEmail, productEmails);
      sendEmail({ emails: template.emails, subject: template.subject, body: template.body });
    },
  };
};
